import * as types from "../../constants";

const initState = {
  processors: "",
  success: "",
};

export default function reducer(state = initState, actions) {
  switch (actions.type) {
    case types.PROCESSORS_RESTART_RESPONSE:
      return {
        ...state,
        processors: "",
        success: "",
      };

    case types.PROCESSORS_LIST_SUCCESS:
      console.log("reducers PROCESSORS list data");
      console.log(actions.response);
      console.log("actions.response.rows:", actions.response.rows);
      console.log("actions.response.results:", actions.response.results);
      return {
        ...state,
        processors: actions.response.rows || actions.response.results || actions.response,
        success: true,
      };

    case types.PROCESSORS_LIST_FAILURE:
      console.log("reducers PROCESSORS list failure");
      console.log(actions);
      return {
        ...state,
        success: false,
        processors: "",
      };

    default:
      return state;
  }
}
